export const eventsRoutes = [
  {
    path: '/admin/events-management',
    name: 'events-management-grid',
    meta: { layout: 'dashboard' },
    component: () => import(/* webpackChunkName: "house-floors" */ './EventsManagementGridView.vue'),
  },
];
